// @flow
/* eslint jsx-a11y/no-static-element-interactions:0 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import BackgroundPinImages from 'app/common/react/components/growth/activation/BackgroundPinImages';
import BEST_GENDER_AGNOSTIC_PIN_IMAGES from 'app/common/react/components/growth/activation/NuxConst/bestGenderAgnosticPinImages';
import changeWindowLocation from 'app/common/lib/util/changeWindowLocation';
import DefaultCSS from 'app/common/react/components/growth/unauth/DefaultCSS';
import ErrorModal from 'app/common/react/components/growth/unauth/ErrorModal/ErrorModal';
import FullPageModalCSS from 'app/common/react/components/growth/unauth/FullPageModal/FullPageModalCSS';
import i18n from 'app/common/lib/i18n';
import InlineStyle from 'app/common/react/components/InlineStyle';
import InspiredInterests from 'app/common/react/components/growth/unauth/home/InspiredInterests/InspiredInterests';
import InspiredWallSignup from 'app/common/react/components/growth/unauth/signup/InspiredWallSignup/InspiredWallSignup';
import PageContext from 'app/common/react/components/growth/unauth/PageContext';
import PropTypes from 'prop-types';
import ResetCSS from 'app/common/react/components/growth/unauth/ResetCSS';
import SignupCSS from 'app/common/react/components/growth/unauth/signup/SignupCSS';
import Toast from 'app/common/react/components/growth/unauth/Toast/Toast';
import ToastCSS from 'app/common/react/components/growth/unauth/Toast/ToastCSS';
import trackRegisterAction from 'app/common/lib/util/trackRegisterAction';
import type { Router } from 'app/common/lib/ReactRouter/types';
import UnauthHomePageCSS from 'app/common/react/components/growth/unauth/UnauthHomePage/UnauthHomePageCSS';
import urlUtil from 'app/common/lib/urlUtil';
import withPlacement from 'app/common/lib/react/experiences/withPlacement';
import { experienceFetch } from 'app/common/redux/actions/experiences';
import { withRouter } from 'react-router';
// eslint-disable-next-line pinterest/no-deprecated-imports
import legacyWithExperiments, {
  type Experiments,
} from 'app/common/lib/react/deprecated/legacyWithExperiments';
import {
  withRequestContext,
  type RequestContextType,
} from 'app/common/react/components/RequestContext';
import { compose, type Dispatch } from 'redux';

const styles = {
  background: {
    bottom: '0px',
    left: '0px',
    right: '0px',
    top: '0px',
    position: 'absolute',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
  backgroundOverlayDesktop: {
    background: 'rgba(0,0,0,.5)',
  },
  errorToast: {
    display: 'flex',
  },
};

const cssStyles = () =>
  DefaultCSS() + UnauthHomePageCSS() + ResetCSS() + SignupCSS() + FullPageModalCSS() + ToastCSS();

type OwnProps = {|
  location?: {
    query?: {
      email?: string,
      show_error?: string,
    },
  },
  options: {
    email?: string,
    show_error?: string,
    sm?: string,
  },
|};

type Props = {|
  ...OwnProps,
  dispatch: Dispatch<any>,
  experiments: Experiments,
  router: Router,
  requestContext: RequestContextType,
|};

type State = {|
  showingSignupWelcomeLoading: boolean,
|};

type Context = {|
  userAgent: {
    canUseNativeApp: boolean,
    isMobile: boolean,
  },
|};

class UnauthHomePage extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      showingSignupWelcomeLoading: false,
    };
  }

  componentDidMount() {
    if (this.props.dispatch) {
      this.props.dispatch(experienceFetch(PCONST.thrift.Placement.UNAUTH_WEB_HOME_PAGE_TAKEOVER));
    }
  }

  context: Context;

  handlePageLevelLoginButtonClick = () => {
    // This metric will drop for modal toggle homepage exps
    // since they use a toggle button instead of a hard refresh
    // See unauth.home.toggle.click for toggle count
    trackRegisterAction('unauth.home.login.click');

    const urlParams = urlUtil.getQueryStringParams();
    let nextWindowLocation = '/login/?referrer=home_page';
    if (urlParams.next) {
      nextWindowLocation += `&next=${urlParams.next}`;
    }

    // TODO (javery) support using the route to push the next window location when the login page has been shipped
    // in Pure React
    // if (this.props.router) {
    //   this.props.router.push(nextWindowLocation);
    //   return;
    // }
    changeWindowLocation(nextWindowLocation, false);
  };

  desktopPage() {
    return (
      <div>
        <div style={styles.background}>
          <div style={{ flex: 1 }}>
            <InspiredWallSignup
              container="home_page"
              email={this.retrieveEmailQueryParam()}
              experiments={this.props.experiments}
              onLoginClick={this.handlePageLevelLoginButtonClick}
              sm={this.props.options.sm}
              handleShowingSignupWelcomeLoading={(shouldShow) =>
                this.setState({ showingSignupWelcomeLoading: shouldShow })
              }
            />
          </div>
          {this.canRenderErrorToast() && this.renderErrorToast()}
          {!this.state.showingSignupWelcomeLoading && <InspiredInterests />}
        </div>
      </div>
    );
  }

  retrieveEmailQueryParam() {
    // TODO (javery) Denzel-only. Remove line when HomePage is no longer rendered in Denzel
    let email = this.props.options.email || '';

    if (this.props.location && this.props.location.query && this.props.location.query.email) {
      email = this.props.location.query.email;
    }

    return email;
  }

  canRenderErrorToast() {
    // Denzel-only TODO (javery) Remove when HomePage is no longer rendered in Denzel
    let {
      options: { show_error },
    } = this.props;

    if (!show_error && this.props.location && this.props.location.query) {
      show_error = this.props.location.query.show_error;
    }

    return show_error === 'true';
  }

  renderErrorToast() {
    const error_title = i18n._('Oof! Looks like the page is broken.');
    const error_subtitle = i18n._("We'll look into it!");

    const className = 'GrowthUnauthToast__container';

    return (
      <div className={className} style={styles.errorToast}>
        <Toast error_title={error_title} error_subtitle={error_subtitle} />
      </div>
    );
  }

  render() {
    const { requestContext } = this.props;

    requestContext.experiments.flush();

    const wrapper = {
      height: '100%',
      width: '100%',
      position: 'absolute',
      top: '0px',
      overflowY: 'hidden',
    };

    let backgroundOverlay = styles.background;
    backgroundOverlay = { ...backgroundOverlay, ...styles.backgroundOverlayDesktop };

    return (
      <PageContext page="home">
        <div style={wrapper}>
          <div>
            <BackgroundPinImages
              disableFlexibleBGPins
              pinImages={BEST_GENDER_AGNOSTIC_PIN_IMAGES}
            />
            {<div style={{ ...backgroundOverlay, position: 'fixed' }} />}
            <InlineStyle unsafeCSS={cssStyles()} />
            {this.desktopPage()}
          </div>
          <ErrorModal />
        </div>
      </PageContext>
    );
  }
}

UnauthHomePage.contextTypes = {
  userAgent: PropTypes.shape({
    canUseNativeApp: PropTypes.bool.isRequired,
    isMobile: PropTypes.bool.isRequired,
  }).isRequired,
};

// $FlowFixMe: new HOC-related type errors after updating withRequestContext
export default compose(
  connect<*, *, _, _, _, _>(),
  withRequestContext,
  legacyWithExperiments,
  withPlacement(PCONST.thrift.Placement.UNAUTH_WEB_HOME_PAGE_TAKEOVER),
  withRouter,
)(UnauthHomePage);
